<template>
  <div class="likert_comment">
    {{comment?.data?.value}}
  </div>
</template>
<script>
import mixin from './_mixin_display_base'
import {EmptyAnswer} from './_mixin_display_base';

export default {
  mixins: [mixin],
  props: {
    statement: {}
  },
  computed:{
    comment(){
      return this.formResultStore.answersByFieldAndOption(this.field.id, this.statement.option_id).find(a=>a.likert_id === null) || EmptyAnswer
    }
  },
}
</script>
<style lang="scss" scoped>
.likert_comment{
  display: block;
  max-width: 320px;
  word-wrap: break-word;
}
</style>